import { showModal, closeModal } from "../lib/render_modal"

window.closeModal = closeModal;
window.showModal  = showModal;